var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonitorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3636 0H1.63636C0.736364 0 0 0.736364 0 1.63636V11.4545C0 12.3545 0.736364 13.0909 1.63636 13.0909H6.54546C6.99732 13.0909 7.36364 13.4572 7.36364 13.9091C7.36364 14.361 6.99732 14.7273 6.54545 14.7273C6.09545 14.7273 5.72727 15.0955 5.72727 15.5455C5.72727 15.9955 6.09545 16.3636 6.54545 16.3636H11.4545C11.9045 16.3636 12.2727 15.9955 12.2727 15.5455C12.2727 15.0955 11.9045 14.7273 11.4545 14.7273C11.0027 14.7273 10.6364 14.361 10.6364 13.9091C10.6364 13.4572 11.0027 13.0909 11.4545 13.0909H16.3636C17.2636 13.0909 18 12.3545 18 11.4545V1.63636C18 0.736364 17.2636 0 16.3636 0ZM15.5455 11.4545H2.45455C2.00455 11.4545 1.63636 11.0864 1.63636 10.6364V2.45455C1.63636 2.00455 2.00455 1.63636 2.45455 1.63636H15.5455C15.9955 1.63636 16.3636 2.00455 16.3636 2.45455V10.6364C16.3636 11.0864 15.9955 11.4545 15.5455 11.4545Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitorIcon.8fd2edee.svg";
export { ForwardRef as ReactComponent };